import { useMemo } from "react";

import { FILTER, SEARCH_KIND } from "@/constants";
import { useEpisodes } from "@/contexts/EpisodesContext";
import useFilterParams from "@/hooks/useFilterParams";
import { formatDateForApi, stringifyQuery } from "@/utils";
import { MENTION_VIEW_DATE_RANGES } from "@/views/MentionsView/MentionLayout/ranges";

export const useAppliedAlertParams = () => {
  const { alert } = useEpisodes();
  const [filters] = useFilterParams();

  const stringifiedFilters = useMemo(() => {
    // The default for the mentions view is set in a constant,
    // However the public view does not know of this.
    // Therefore pass along the defaults if nothing's set from
    // the URL.
    let _filters = {};

    if (alert?.kind !== SEARCH_KIND.SAVED) {
      const defaultRange = MENTION_VIEW_DATE_RANGES.find(
        (range) => range.default
      );
      if (defaultRange) {
        _filters = {
          [FILTER.START_DATE]: defaultRange.startDate
            ? formatDateForApi(defaultRange.startDate)
            : null,
          [FILTER.END_DATE]: defaultRange.endDate
            ? formatDateForApi(defaultRange.endDate)
            : null,
        };
      }
    }

    return stringifyQuery({ ..._filters, ...filters });
  }, [filters, alert]);
  return stringifiedFilters;
};
